const WishlistIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M12 21l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4c1.74 0 3.41 1.01 4.22 2.53C11.3 5.01 12.97 4 14.7 4 17.2 4 19.2 6 19.2 8.5c0 3.78-3.4 6.86-8.05 11.18L12 21z'
      fill='currentColor'
    />
  </svg>
);

export default WishlistIcon;
